/** Text file types */
export const TEXT_FILE_TYPES = [
    'txt',
    'docx',
    'pdf',
    'xlsx',
    'csv',
    'md',
    'json',
    'html',
    'xml',
];
